export function removeUndefined<T extends Record<string, unknown>>(
  obj: T,
  empty: unknown[] = [],
  removeEmptyObjects = false,
  clearableFields: string[] = [],
): T {
  const newObj: Record<string, unknown> = {};
  const emptyValues = [undefined, ...empty];
  Object.entries(obj).forEach(([k, v]) => {
    if (Array.isArray(v)) {
      newObj[k] = obj[k];
    } else if (v === Object(v)) {
      if (removeEmptyObjects) {
        const newSubObj = removeUndefined(v as Record<string, unknown>, empty, removeEmptyObjects, clearableFields);
        if (Object.keys(newSubObj).length > 0) {
          newObj[k] = {
            ...newSubObj,
          };
        }
      } else {
        newObj[k] = removeUndefined(v as Record<string, unknown>, empty);
      }
    } else if (!emptyValues.includes(v) || clearableFields.includes(k)) {
      newObj[k] = obj[k];
    }
  });
  return newObj as T;
}
